/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWebhookOff = createReactComponent("webhook-off", "IconWebhookOff", [
  ["path", { d: "M4.876 13.61a4 4 0 1 0 6.124 3.39h6", key: "svg-0" }],
  [
    "path",
    {
      d: "M15.066 20.502a4 4 0 0 0 4.763 -.675m1.171 -2.827a4 4 0 0 0 -4 -4",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M16 8a4 4 0 0 0 -6.824 -2.833m-1.176 2.833c0 1.506 .77 2.818 2 3.5l-3 5.5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M3 3l18 18", key: "svg-3" }]
]);

export { IconWebhookOff as default };
//# sourceMappingURL=IconWebhookOff.js.map
